import TextAreaField from './textAreaField';

export default TextAreaField;
